import { queryClient } from './queryClient';

export function invalidateAllCurriculumData() {
  queryClient.invalidateQueries({
    predicate: (query) => {
      const key = query.queryKey[0];
      if (typeof key !== 'string') return false;
      
      return (
        key.startsWith('/api/admin/grades') ||
        key.startsWith('/api/admin/subjects') ||
        key.startsWith('/api/admin/topics') ||
        key.startsWith('/api/subjects') ||
        key.startsWith('/api/curriculum') ||
        key.startsWith('/api/topics') ||
        key.startsWith('/api/questions')
      );
    },
  });
}

export function invalidateGrades() {
  invalidateAllCurriculumData();
}

export function invalidateSubjects() {
  invalidateAllCurriculumData();
}

export function invalidateTopics() {
  invalidateAllCurriculumData();
}
